import React from "react";

export const CARD_ELEMENT_OPTIONS = {
  style: {
    base: {
      iconColor: "#666EE8",
      color: "#31325F",
      lineHeight: "40px",
      fontWeight: 300,
      fontSize: "15px",
      "::placeholder": {
        color: "#CFD7E0",
      },
      width: "max-content",
    },
    invalid: {
      color: "#fa755a",
      iconColor: "#fa755a",
    },
  },
};
export const CHECKOUT_TYPE_OPTIONS = {
  MONTHLY: {
    label: "Monthly",
    value: "monthly",
  },
  YEARLY: {
    label: "Annual",
    value: "yearly",
  },
};
export const subscriptionFailSwalArgs = {
  title: "Please verify your payment method",
  icon: "error",
  text: "There was an issue with the payment information you input. Please try another payment method or card.",
};
export const PLANS_DATA = [
  {
    title: "Basic",
    badge: null,
    monthlyPrice: 0,
    yearlyPrice: 0,
    benefits: ["Access new appointments starting from 8:30 AM"],
    planId: 3,
  },
  {
    title: "Premier",
    badge: "Most Popular",
    monthlyPrice: 99.99,
    yearlyPrice: 999,
    benefits: [
      <>
        Access new appointments starting from <strong>8:00 AM</strong>
      </>,
      "Instant notifications when an appointment becomes available",
      "Transfer, Receive and Trade appointments with other Premier Subscribers",
    ],
    planId: 5,
  },
  {
    title: "Plus",
    badge: null,
    monthlyPrice: 19.99,
    yearlyPrice: 200,
    benefits: [
      <>
        Access new appointments starting from <strong>8:30 AM</strong>
      </>,
      "Instant notifications when an appointment becomes available",
    ],
    planId: 4,
  },
];
